import React, { useContext, useEffect, useState } from "react";
import AntdTable from "../../../antd/Table/Table";
import { filtrationcontext } from "../../../../context/Filtercontext";
import trans, { isRTL } from "../../../../utils";
import { render } from "@testing-library/react";
import { Tag } from "antd";
import { WorkloadStatusColor } from "../../../../constants";
import { useReportTableColumns } from "../../ReportColumns/reportColumns";

const ProductivityReportTable = ({
  startDate,
  endDate,
  currentPage,
  setCurrentPage,
  data,
  isLoading,
}) => {
  //   const { setFileName, setExportIds, setStartDateE, setEndDateE } =
  //     useContext(exportContext);
  const {
    setSort: SetSortFilter,
    limit,
    setLimit,
  } = useContext(filtrationcontext);
  const [sort, setSort] = useState({
    by: "",
    order: "",
  });

  useEffect(() => {
    return () => {
      SetSortFilter({ type: "", value: "" });
      localStorage.setItem("page", 1);
    };
  }, [SetSortFilter]);

  const columns = [
    {
      title: trans("staff name"),
      dataIndex: "staffName",
      width: 150,
      sorter: true,
      fixed: !isRTL ? "left" : undefined,
      render: (name) => (
        <span className={"table-element-name ps-0"}>{name}</span>
      ),
    },
    {
      title: trans("processed tasks"),
      dataIndex: "completedTasks",
      width: 150,
      sorter: true,
    },
    {
      title: trans("performance"),
      dataIndex: "isUnderperforming",
      width: 150,
      render: (value) => (
        <Tag color={value ? "red" : "green"} className="text-capitalize">
          {value ? trans("Under Performing") : trans("Out Performing")}
        </Tag>
      ),
    },

    {
      title: trans("Avg Expected (min)"),
      dataIndex: "avgExpectedDuration",
      width: 150,
      sorter: true,
      render: (_, record) => record?.formattedExpected || "0",
    },
    {
      title: trans("Avg Actual(min)"),
      dataIndex: "avgActualDuration",
      width: 150,
      sorter: true,
      render: (_, record) => record?.formattedActual || "0",
    },
    {
      title: trans("Efficiency %"),
      dataIndex: "efficiency",
      width: 150,
      sorter: true,
      render: (_, record) => {
        let className = "text-danger";
        if (record?.isUnderperforming === false) {
          className = "text-success fw-bold";
          // } else if (record?.efficiency > 85) {
          //   className = "text-success"; //
          // }
          // else if (record?.efficiency > 70) {
          //   className = "text-warning";
        } else {
          className = "text-danger";
        }
        return (
          <span className={className}>
            {record?.formattedEfficiency || "0"}
          </span>
        );
      },
    },
    {
      title: trans("Tasks Assigned"),
      dataIndex: "totalTasks",
      width: 150,
      sorter: true,
    },
    {
      title: trans("Workload Status"),
      dataIndex: "workloadStatus",
      width: 150,
      sorter: true,
      render: (value) => (
        <Tag
          color={WorkloadStatusColor[value] || WorkloadStatusColor.default}
          className="text-capitalize"
        >
          {trans(value)}
        </Tag>
      ),
    },
  ];
  const visibleColumns = useReportTableColumns(columns);

  //   useEffect(() => {
  //     if (data) {
  //       setFileName("Summary Report");
  //       setExportIds(selectedids);
  //       setStartDateE(startDate);
  //       setEndDateE(endDate);
  //     }
  //   }, [data, startDate, endDate, selectedids]);

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      SetSortFilter({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      SetSortFilter({
        by: "",
        order: "",
      });
    }
  };

  return (
    <div className="bg-white-rounded-top mt-3 table-parent">
      <AntdTable
        columns={visibleColumns}
        dataSource={data?.staffPerformance || []}
        loading={isLoading}
        pageSize={limit}
        totalItems={data?.totalResults || 0}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        onLimitChange={(newLimit) => {
          setLimit(newLimit);
          setCurrentPage(1);
        }}
        onTableChange={handleTableChange}
        scrollY={350}
      />
    </div>
  );
};

export default ProductivityReportTable;
